import Gallery from '../gallery/gallery';
import { IJsonNewsAndStories } from '../../live-pages/news-and-stories/interfaces';
import { sendGAEvent } from '../../../domain/marketing/gtm-provider';
import Imgix from 'react-imgix';
import { format } from 'date-fns';
import React from 'react';
import { IBlogVideo } from './interfaces';
import { getImgCDNDomain } from '../../../domain/common';

interface IBlogByTagGallery {
    data: IBlogVideo[];
    isShowHalf: boolean;
    isShowVideoDetails: boolean;
}

const decodeHTML = (html: string) => {
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
};

const BlogByTagGallery = ({ data, isShowHalf, isShowVideoDetails }: IBlogByTagGallery) => {

    const imgDomain = getImgCDNDomain();

    return (
        <div className="w-full mx-auto">
            <Gallery
                classes={'waves-box-lg mx-auto px-5 md:px-12 mb-20'}
                style={{
                    width: '1497px',
                    minHeight: '300px'
                }}
                desktopItemsPerSlide={ data.length === 2 ? 2 : isShowHalf ? 3.5 : 3 }
                tableItemsPerSlide={ isShowHalf ? 2.5 : 2 }
                mobileItemsPerSlide={ 1.5 }
                codeName="fmo"
                items={ data }
                loop={ false }
                duration={ 800 }
                gap={ 40 }
                arrowsHeightWidthRatio={ 9 / 16 }
                renderItem={(item: IJsonNewsAndStories, slideItemWidth: number) => {
                    const name = decodeHTML(item.documentName);
                    return (
                        <>
                            <div style={{ width: slideItemWidth }}><a
                                className="block no-underline"
                                href={item.documentUrlPath}
                                onClick={(evt) => {
                                    sendGAEvent('NewsAndStories', name);
                                }}>
                                <Imgix
                                    src={`${imgDomain}${item.previewImage}`}
                                    className="max-w-full"
                                    htmlAttributes={{
                                        alt: name,
                                        title: name,
                                        loading: 'lazy',
                                    }}
                                    height={(slideItemWidth / 16) * 9}
                                    width={slideItemWidth}
                                />
                            </a>
                                {
                                    isShowVideoDetails && <div className="pt-6 pb-3">
                                        {
                                            item.isVideo && <span
                                                className="border border-blue-200 font-medium rounded text-xs text-gray-500 py-1 px-2 mr-2">Video</span>
                                        }
                                        {
                                            !item.isVideo && <span
                                                className="border border-blue-200 font-medium rounded text-xs text-gray-500 py-1 px-2 mr-2">Blog</span>
                                        }
                                        <span
                                            className="text-xs text-gray-500 mr-1 font-medium">{format(new Date(item.postDate), 'MMM dd,yyyy')}</span>
                                        {
                                            item.isVideo && <span className="text-xs mr-1 font-medium">&bull;</span>
                                        }
                                        {
                                            item.isVideo && <span
                                                className="text-xs text-gray-500 font-medium">{item.viewCount} Views</span>
                                        }
                                    </div>
                                }
                                <div>
                                    <p className={'pb-6'}><a href={item.documentUrlPath}
                                                             className="waves-h4 sm:text-lg font-medium text-gray-700 no-underline ">{name}</a>
                                    </p>
                                    <a href={item.documentUrlPath}
                                       className="no-underline text-gray-700 text-sm md:text-base inline-block">Explore
                                        <svg className="inline-block ml-2" width="7" height="10" viewBox="0 0 7 10"
                                             fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" clipRule="evenodd"
                                                  d="M1.7624 0.588032C1.43779 0.263305 0.911368 0.263305 0.586758 0.588031C0.262563 0.912343 0.262277 1.43794 0.586118 1.76261L3.8153 5L0.586118 8.23739C0.262277 8.56206 0.262563 9.08766 0.586758 9.41197C0.911368 9.7367 1.43779 9.7367 1.7624 9.41197L6.17278 5L1.7624 0.588032Z"
                                                  fill="#1D1D1D"/>
                                        </svg>
                                    </a>
                                </div>
                            </div>
                        </>
                    )
                }}
            />
        </div>
    )
};

export default BlogByTagGallery;